module.exports = __webpack_public_path__ + "static/media/empresariales3-min.6eacd929.jpg";